import { UseQueryOptions } from '@tanstack/react-query';
import { AxiosMethods } from '../../../../enums';
import { axiosHelper } from '../../../axios-instance';
import { QuoteDTO } from './types';

export * from './types';

export enum QuotesQueryKey {
  QUOTE_DETAILS = 'quote_details',
  QUOTE_PREVIEW = 'quote_preview'
}

/**
 * Get quote details by ID
 */
export const getQuoteDetails = (
  quoteId: string
): UseQueryOptions<QuoteDTO> => ({
  refetchOnMount: 'always',
  staleTime: 0,
  cacheTime: 0,
  queryKey: [QuotesQueryKey.QUOTE_DETAILS, quoteId],
  enabled: !!quoteId,
  queryFn: () =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: `/quote/${quoteId}`,
      method: AxiosMethods.GET
    })
});

/**
 * Get quote preview
 */
export const getQuotePreview = (quoteId: string) => ({
  queryKey: [QuotesQueryKey.QUOTE_PREVIEW, quoteId],
  queryFn: () =>
    axiosHelper({
      endpoint: `/quote/${quoteId}/preview`,
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    }),
  enabled: false
});
